<template>
<v-container fluid id="homeGrid">
  <!--=================================================SPECIALTY TAG=======-->
  <div class="specialty turqBg d-flex justify-center align-center" id="about">
		<h1 class="cab fw6" id="speTxt">
			Freelance Web Developer & Designer based out of British Columbia, Canada.
			<br class="speBr"> I specialize in the responsive design and 
			development of attractive, functional websites.
		</h1>
		<div class="noise noise008"></div>
  </div>
  <!--=================================================ABOUT ME & IMG======-->
  <div class="aboutRow whiteBg d-flex justify-center flex-wrap align-center">
		<h1 class="aboutme mont drkGrey fw5">
			Hi, I'm Kevin :) I'm a perpetually curious, critical thinker, 
			with a passion for design and development
		</h1>
    <div class="cartoonMe d-flex justify-center align-center" >
      <img class="meImg" src="../../images/artwork/Me.jpg" >
    </div>
  </div>
  <!--===================================================STAR BLOCK============-->
	<div class="starBlock d-flex">
		<div class="noise noiseStars"></div>
		<div class="whiteBlock d-flex"></div>
	</div>
	<!--===================================================SKILLS============-->
	<div class="skills d-flex justify-center flex-wrap" id="dezdiz">
		<div class="left d-flex flex-column align-center">
				<div class="d-flex justify-center align-center">
					<img class="devLogo" src="../../images/icons/siteIcons-01.png">
				</div>
				<h1 class="purp split cab ceTxt mt-8 fw6 ">
					Design
				</h1>
				<h3 class="drkGrey split mont ceTxt mt-4 w85 fw4">
					I originally attended the Ontario College of Art & Design
					University (OCADU) in Toronto, for Graphic Design, where I refined
					my own aesthetic and learned design best practices.
				</h3>
				<h2 class="turq split cab ceTxt mt-4 fw6">
					Services
				</h2>
				<h3 class="drkGrey mont split ceTxt mt-4 w80 fw4">
					Web design, UI, UX, Logos, Illustrations & Web Graphics
				</h3>
				<h2 class="turq split cab ceTxt mt-4 fw6">
					Design Tools
				</h2>
				<h3 class="drkGrey mont split ceTxt mt-4 fw4">
					&#8226; Vuetify<br>
					&#8226; Bootstrap<br>
					&#8226; Pencil & Paper<br>
					&#8226; Adobe Illustrator<br>
					&#8226; Adobe Photoshop<br>
					&#8226; Adobe Xd<br>
					
				</h3>
		</div>
		<!-- ===============================================DEVELOPMENT========= -->
		<div class="right d-flex flex-column align-center">
				<div class="d-flex justify-center align-center">
					<img class="devLogo" src="../../images/icons/siteIcons-02.png" >
				</div>
				<h1 class="purp split cab ceTxt mt-8 fw6">
					Development
				</h1>
				<h3 class="drkGrey mont split ceTxt mt-4 w85 fw4">
					I graduated from Dalhousie University, In Halifax, 
					with a Double Major in Computer Science and Neuroscience, 
					which has given me the skills to solve problems and 
					build functional applications.
				</h3>
				<h2 class="turq split cab ceTxt mt-4 fw6">
					Languages I Use
				</h2>
				<h3 class="drkGrey mont split ceTxt mt-4 w80 fw4">
					JavaScript, HTML, CSS, Liquid, Java, C++, C & Python
				</h3>
				<h2 class="turq split cab ceTxt mt-4 fw6 ">
					Development Tools
				</h2>
				<h3 class="drkGrey mont split ceTxt mt-4 fw4">
					&#8226; VS Code<br>
					&#8226; Vue.js<br>`
					&#8226; React<br>
					&#8226; Node.js<br>
					&#8226; MongoDB<br>
					&#8226; SQL<br>
				</h3>
		</div>
	</div>
	<!-- ===========================================================RECENT WORK -->
	<div class="recentWork d-flex justify-center flex-wrap pt-12" style="margin-top: -300px;" id="recent-work">
		<h1 class="mainH cab ceTxt drkGrey fw7 pt-2 pb-2 ">Current Work</h1>
		<div class="d-flex justify-center flex-wrap mt-12">
			<a :href="Projects[1].link" tag="div" class="projCards">
				<project-card 
						:url="Projects[1].url"
						:title="Projects[1].title"
						:text="Projects[1].text"
						:link="Projects[1].link"
						:Projlink="Projects[1].Projlink"
						:inApp="Projects[1].inApp">
				</project-card>
			</a>
			<router-link :to="Projects[0].link"  tag="div" class="projCards">
				<project-card 
						:url="Projects[2].url"
						:title="Projects[2].title"
						:text="Projects[2].text"
						:link="Projects[2].link"
						:Projlink="Projects[2].Projlink"
						:inApp="Projects[2].inApp">
				</project-card>
			</router-link>
		</div>
	</div>
</v-container>
</template>
<!--=================================================================================-->
<!--=====================================================================SCRIPTS=====-->
<!--=================================================================================-->
<script>
import ProjectCard from '../Projects/ProjectCard.vue';
import Projects from '../Projects/Projects.json';

export default {
	name: "HomeGrid",
	components: { ProjectCard},
	data() {
		return {
			Projects,
			width: window.innerWidth,
			height: window.innerHeight,
			infoH: 1000
		}
	}
}
</script>
<!--=================================================================================-->
<!--=====================================================================STYLING=====-->
<!--=================================================================================-->
<style>
.homegrid{
	position: relative;
  width: 100%;
  top: 100vh !important;
  height: auto;
  padding: 0;
	margin: 0;}
.ender{
	position: relative;
	height: 30px;}
/*========================================HOME GRID====*/
#homeGrid,.container-fluid{
	position: relative;
	width: 100vw;
	max-width: 100%;
	top: 0;
	left: 0;
	right: 0;
	margin: 0;
	padding: 0;
	overflow: hidden;}
.fill{ position: relative;}
/*=============================MY-SPECIALTY==========*/
.specialty {height: calc(15vh + 6vw); position: relative;}
#speTxt {
	color: white; 
	width: 90%;
	text-align: center;
	font-size: calc(10px + 1.3vw);
	line-height: calc(10px + 1.4vw);}
.speBr {display: inline;}
.noise008{ opacity: 0.12; z-index: 100;}
.noiseStars{opacity: 0.15; z-index: 0;}
/*=================================SHORT-BIO=========*/
.aboutRow { height: auto; overflow: hidden;}
.aboutme {
	position: relative;
	width: 40vw;
	margin-left: 3vw;
	margin-right: 3vw;
	z-index: 10;
	margin-top: 5vw;
	margin-bottom: 5vw;
	text-align: center;
	font-size: calc(10px + 1.3vw);
	line-height: calc(10px + 1.6vw);
	z-index: 20;}
.cartoonMe {
	position: relative;
	top: -1vw;
	margin: 2vw;
	height: auto;
	width: auto;
	object-fit: contain;}
.meImg{
	object-fit: contain;
	width: 28vw;
	min-width: 300px;}
/*=====================================SKILLS & TOOLS==*/
.starBlock{ 
	position: relative; 
	height: 55vh;
	background-color: #8D469E55;}
.whiteBlock{ 
	position: absolute;
	top: 100%;
	left: 0;
	height: 130vh;
	width: 100vw;
	background-color: white;}
.skills {
	position: relative;
	top: calc( -45vh + 7vw);
	height: auto;
	width: 100%;
	overflow: visible;}
.left, .right {
	position: relative;
	width: 36vw;
	min-width: 320px;
	max-width: 900px;
	height: auto;
	background-color: white;
	border: 1px solid #BCBCBC;
	border-bottom: 0px;
	z-index: 2;
	padding-bottom: 30px;}
.left {
	border-top-left-radius: 1vw;
	border-right: 0px;}
.right {
	border-top-right-radius: 1vw;}
.split{ display: block; position: relative;}
h1.split{ font-size: calc(20px + 1vw);}
h2.split {font-size: calc(10px + 1vw);}
h3.split {font-size: calc(8px + 0.6vw);}
.devLogo {
	position: relative;
	object-fit: contain;
	top: 3vw;
	width: 8vw;
	height: 6vw;
	margin: 2vw 0;}
/* ==========================================RECENT WORK===== */
.mainH{ font-size: calc(20px + 1vw);}
.myDevStack{
	position: relative;
	z-index: 10;
	margin-top: calc( -37vh + 7vw);
	background-color: #4EA792;}
.noiseStack{ z-index: 0 !important; opacity: 0.12;}
.recentWork{
	width: 100%;
	position: relative;
	z-index: 10;
	height: auto;
	padding-top:40px;
	background-color: white;
	padding-bottom: 130px;
	background-color: white;}
.projCards{
  position: relative;
  margin: 2vw;
	width: 40vw;
	min-width: 300px;
	max-width: 800px;}
/*=====================================================*/
/*========================!!RESONSIVITY!!==============*/
/*=====================================================*/
/*=================================================SM==*/
@media screen and (max-width: 850px) {
	.devLogo { width: 10vw; height: 12vw;}
	.left, .right {
		width: 60vw;
		border: 1px solid #BCBCBC;
		height: auto;
		border-top-left-radius: 2vw;
		border-top-right-radius: 2vw;}
	.right {
		border: 1px solid #BCBCBC;
		border-top-left-radius: 0vw;
		border-top-right-radius: 0vw;
		border-bottom-left-radius: 2vw;
		border-bottom-right-radius: 2vw;}
	.aboutme {
		width: 80vw;
		margin-top: 8vw;
		margin-bottom: 0vw;}
	.cartoonMe { margin-bottom: 8vw;}
	.speBr {display: none;}}
/* =================================Stack */
.stackHolder{
  position: relative;
	width: 100vw;
  height: auto;
  background: none;
  margin: 20px 5vw;
  overflow: hidden !important;}
.frontEnd, .backEnd{
  width: 80vw;
	min-width: 320px;
	max-width: 550px;
	height: auto;
  overflow: hidden !important;
  border-radius: 20px;
  background-color: #282828;}
.frontStack, .backStack{ width: 100%; overflow: hidden;}
.frontStack{ border-top-right-radius: 20px;}
.backStack{ border-bottom-left-radius: 20px;}
.lgTitle, .mdTitle, .smTitle, .dependancy{ width: 100%;}
.lgTitle{
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;}
.d1{ background-color: #09314777; }
.d2{ background-color: #00000044;}
.endTitle{
  width: 100%;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;}
.noiseStack{ z-index: 0;opacity: 0.11;}
.stackLogo{
	position: relative;
	display: inline-block;
	height: 35px;
	width: 40px;
	background-size: contain;}
.vuetify{ background-image: url('https://cdn.vuetifyjs.com/images/logos/vuetify-logo-light.png');}
.vue{ 		background-image: url('../../images/logo/vueLogo.png');}
.node{  	background-image: url('../../images/logo/nodeLogo.png');}
.nginx{ 	background-image: url('../../images/logo/nginxLogo.png');}
.mongo{ 	background-image: url('https://www.mongodb.com/assets/images/global/favicon.ico');}
.webpack{ background-image: url('https://webpack.js.org/icon_192x192.png');}
.matrixGreen{color: #00ff41;}
</style>

